/* eslint-disable react/prop-types */
/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */
// @ts-nocheck

import Octicon, { getIconByName } from '@githubprimer/octicons-react'
import { colors } from '@lmc/common/constants'
import { Icon, IconType, theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Tooltip } from 'antd'
import { getCleanRoute } from 'hooks/useRouteMatch'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { history } from '../../../store'

export type TabBarItem = {
  url: string
  search?: string | (() => string)
  label: string
}

export default class TabBar extends Component {
  componentDidMount() {
    // We want to update tab state (currently active)
    // every time a route changes. This listener lets us do that.
    history.listen(() => {
      this.forceUpdate()
    })
  }

  isActive = (url) => {
    const { pathname } = history.location
    if (pathname) {
      if (url === 'patterns') {
        return (
          !!pathname.match(url) ||
          !!pathname.match(/\/rota\/[^/]+\/(visit|shift)(\/edit)?$/)
        )
      }
      return !!pathname.match(url)
    }
  }

  renderLabel = (item) => {
    const desktopLabel = item.label
    let mobileLabel
    if (item.octicon) {
      mobileLabel = <Octicon icon={getIconByName(item.octicon)} />
    } else if (item.customIcon) {
      mobileLabel = (
        <Icon customIcon={item.customIcon} style={mobileStyles.icon} />
      )
    } else if (item.icon) {
      mobileLabel = (
        <Icon
          name={item.icon}
          size={16}
          fill={null}
          style={mobileStyles.icon}
        />
      )
    } else {
      mobileLabel = item.mobileLabel || item.label
    }
    return isBrowser || isTablet ? desktopLabel : mobileLabel
  }

  renderItems() {
    const { resourceId, items, resourceUrl, hasRota } = this.props
    const baseUrl = `/${resourceUrl}`
    const styles = isBrowser || isTablet ? desktopStyles : mobileStyles
    const cleanRoute = getCleanRoute(history?.location?.pathname, {
      id: history?.location?.pathname.split('/')[3]
    })

    if (cleanRoute.startsWith('/organisation/team/[id]') && hasRota) {
      return null
    }

    return items.map((item: TabBarItem) => {
      const location = history.location.pathname
      const exceptionConditions = [
        item.url === 'list' && location.endsWith('/profile'),
        item.url === 'list' && location.endsWith('/profile/edit'),
        item.url === 'list' && location.endsWith('/skills')
      ]

      const isActive =
        exceptionConditions.some((condition) => condition) ||
        this.isActive(item.url)

      const activeStyles = isActive ? desktopStyles.activeItem : null

      const url = resourceId
        ? `${baseUrl}/${resourceId}/${item.url}`
        : `${baseUrl}/${item.url}`

      const disabledStyles = item.disabledByPermission
        ? { pointerEvents: 'none', opacity: 0.5 }
        : {}

      if (item.renderLabel) {
        return (
          <span key={item.url}>
            {item.renderLabel({
              baseUrl: url,
              isActive: this.isActive(item.url)
            })}
          </span>
        )
      }

      const isDisabled = item?.disabledByPermission

      const search =
        typeof item.search === 'function' ? item.search() : item.search

      const navComponent = (
        <li
          className={`${
            !this.props.oldNavigation
              ? 'lmc-secondary-nav-link'
              : 'lmc-secondary-nav-link-old '
          }`}
          key={item.url}
          style={{
            ...styles.item,
            ...activeStyles,
            ...(isDisabled && disabledStyles)
          }}
        >
          <Link
            data-cy={`btn-nav-${item?.label?.toLowerCase()}`}
            className={`${
              !this.props.oldNavigation
                ? 'lmc-secondary-nav-link'
                : 'lmc-secondary-nav-link-old '
            }`}
            to={{
              pathname: url,
              search
            }}
            style={
              isActive
                ? { color: !this.props.oldNavigation ? 'white' : '#330066' }
                : {}
            }
            {...(isDisabled && { onClick: (e) => e?.preventDefault() })}
          >
            {this.renderLabel(item)}
          </Link>
        </li>
      )

      if (isDisabled) {
        return (
          <Tooltip
            placement="bottom"
            color={theme.color.neutral.color3}
            title={
              <TooltipTextWrapper>
                <Icon customIcon={IconType.CircleXIcon} />
                <StyledText level={1}>Permissions required</StyledText>
              </TooltipTextWrapper>
            }
          >
            <div>{navComponent}</div>
          </Tooltip>
        )
      }

      return navComponent
    })
  }

  render() {
    const styles = isBrowser || isTablet ? desktopStyles : mobileStyles

    const isMobile = !isBrowser && !isTablet

    if (isMobile && !this.props.isMobileEnabled) return null

    return (
      <div style={styles.backgroundContainer} data-testid={this.props.testId}>
        <nav
          className="secondary-navbar"
          style={{
            ...styles.navbar,
            ...this.props.style,
            ...(!this.props.oldNavigation && {
              backgroundColor: theme.color.background.secondary,
              color: theme.color.neutral.color7
            })
          }}
        >
          <ul
            className={`app-nav app-nav--left ${
              !this.props.oldNavigation ? '' : 'app-nav--secondary'
            }`}
            style={styles.list}
          >
            {this.renderItems()}
          </ul>
        </nav>
      </div>
    )
  }
}

const desktopStyles = {
  activeItem: {
    borderBottom: `4px solid ${colors.pink}`,
    marginBottom: 0
  },
  item: {
    boxSizing: 'border-box',
    marginBottom: 3,
    textAlign: 'center'
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  navbar: {
    display: 'flex',
    fontWeight: 500,
    paddingLeft: 15,
    paddingRight: 0
  }
}

const mobileStyles = {
  backgroundContainer: {
    minHeight: 40,
    width: '100%'
  },
  icon: {
    verticalAlign: 'text-bottom',
    fill: 'none'
  },
  item: {
    boxSizing: 'border-box',
    color: colors.darkgrey,
    textAlign: 'center'
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%'
  },
  navbar: {
    minHeight: 40,
    backgroundColor: colors.white,
    position: 'fixed',
    width: '100%',
    zIndex: 2
  }
}

const TooltipTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color11};
`

TabBar.propTypes = {
  items: PropTypes.array,
  resourceId: PropTypes.string,
  resourceUrl: PropTypes.string,
  isMobileEnabled: PropTypes.bool,
  isRosteringEnabled: PropTypes.bool,
  testId: PropTypes.string
}

TabBar.defaultProps = {
  resourceUrl: 'residents',
  isMobileEnabled: false,
  items: [{ label: 'Profile', url: 'profile', octicon: 'file' }]
}
